import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { ComboPreventionResult } from '../../services/validators/combo-prevention/combo-prevention-result.enum';
import { BetPlacementErrorIcon } from '../bet-placement-error-icon';
import { stringToNullableNumber } from '../error-convert-helpers';
import { ResultError } from './result-error';

export enum BposComboPreventionReason {
    /// <summary>
    /// UnknownReason
    /// </summary>
    UnknownReason = 'UnknownReason',
    /// <summary>
    /// AllCombo
    /// </summary>
    AllCombo = 'AllCombo',
    /// <summary>
    /// No combination allowed for these results
    /// </summary>
    NoComboAllowed = 'NoComboAllowed',
    /// <summary>
    /// Results should be from different sports
    /// </summary>
    SameSport = 'SameSport',
    /// <summary>
    /// Results should be from different league
    /// </summary>
    SameLeague = 'SameLeague',
    /// <summary>
    /// Results should be from different events
    /// </summary>
    SameEvent = 'SameEvent',
    /// <summary>
    /// Results should be from the same league
    /// </summary>
    DifferentLeague = 'DifferentLeague',
    /// <summary>
    /// Results should be LIVE
    /// </summary>
    NonLiveEvent = 'NonLiveEvent',
    /// <summary>
    /// Results should be from different LIVE events
    /// </summary>
    SameLiveEvent = 'SameLiveEvent',
    /// <summary>
    /// Results should be from different games
    /// </summary>
    SameGame = 'SameGame',
    /// <summary>
    /// Picks should be from different fixtures
    /// </summary>
    SameFixture = 'SameFixture',
    /// <summary>
    /// Picks should be from different fixture pools
    /// </summary>
    SameFixturePool = 'SameFixturePool',
    /// <summary>
    /// Picks should be for different participant pools
    /// </summary>
    SameParticipantPool = 'SameParticipantPool',
    /// <summary>
    /// Picks should be for different participants
    /// </summary>
    SameParticipant = 'SameParticipant',
    /// <summary>
    /// Bet type is not allowed
    /// </summary>
    BetTypeNotCombinable = 'BetTypeNotCombinable',
}

export class ComboPreventionPickError extends ResultError {
    incompatibleOptionId: number | null;
    reason: ComboPreventionResult;

    incompatiblePicks: {
        [id: string]: ComboPreventionResult;
    };

    constructor(pickId: string, comboPreventionReason: string | undefined) {
        super(pickId);
        this.incompatibleOptionId = stringToNullableNumber(comboPreventionReason);
        this.reason = this.mapComboPreventionReason((comboPreventionReason || BposComboPreventionReason.NoComboAllowed) as BposComboPreventionReason);
        this.icon = BetPlacementErrorIcon.Warning;
        this.incompatiblePicks = {};
        this.hasClientValidation = false;
        this.type = PlacementErrorType.ComboPrevention;
    }

    private mapComboPreventionReason(bposReason: BposComboPreventionReason): ComboPreventionResult {
        switch (bposReason) {
            case BposComboPreventionReason.AllCombo:
                return ComboPreventionResult.AllCombo;
            case BposComboPreventionReason.BetTypeNotCombinable:
                return ComboPreventionResult.NoComboAllowed;
            case BposComboPreventionReason.DifferentLeague:
                return ComboPreventionResult.DifferentLeague;
            case BposComboPreventionReason.NoComboAllowed:
                return ComboPreventionResult.NoComboAllowed;
            case BposComboPreventionReason.NonLiveEvent:
                return ComboPreventionResult.NoComboAllowed;
            case BposComboPreventionReason.SameEvent:
                return ComboPreventionResult.SameEvent;
            case BposComboPreventionReason.SameFixture:
                return ComboPreventionResult.SameFixture;
            case BposComboPreventionReason.SameFixturePool:
                return ComboPreventionResult.SameFixture;
            case BposComboPreventionReason.SameGame:
                return ComboPreventionResult.SameEvent;
            case BposComboPreventionReason.SameLeague:
                return ComboPreventionResult.SameLeague;
            case BposComboPreventionReason.SameLiveEvent:
                return ComboPreventionResult.SameEvent;
            case BposComboPreventionReason.SameParticipant:
                return ComboPreventionResult.SameRaceParticipant;
            case BposComboPreventionReason.SameParticipantPool:
                return ComboPreventionResult.SameRaceParticipant;
            case BposComboPreventionReason.SameSport:
                return ComboPreventionResult.SameSport;
            case BposComboPreventionReason.UnknownReason:
                return ComboPreventionResult.NoComboAllowed;
            default:
                return ComboPreventionResult.NoComboAllowed;
        }
    }
}
